import Component from '../core/Component'

export default class SimpleMap extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            map: null
        }

        this.points = this.options.points
        this.observer = new IntersectionObserver(this.handleIntersection, {
            threshold: 0,
        })
    }

    prepare() {
        if (this.ref.map) {
            this.observer.observe(this.ref.map)
        }
    }

    destroy() {
        if (this.observer) {
            this.observer.unobserve(this.ref.map)
        }
    }

    handleTogglerClick = () => {
        this.toggleMap()
    }

    handleIntersection = (entries) => {
        entries.forEach((entry) => {
            if (entry.target === this.ref.map && entry.isIntersecting) {
                this.initializeMap()
                this.observer.unobserve(this.ref.map)
            }
        })
    }

    async initializeMap() {
        if (!this.ref.map || this.map) {
            return
        }

        const mod = await import('./Map.js')
        const Map = mod.default
        const MAP_EMITS = mod.EMITS
        this.map = new Map(this.ref.map, {
            maxZoomOnBounds: 14
        })

        const handleMapMarkerClick = (event) => {
            //
        }

        this.map.on(MAP_EMITS.MARKER_CLICK, handleMapMarkerClick)
        await this.map.prepare()
        await this.map.show(this.points)
        await this.map.fit(null, { top: 40, left: 40, right: 40, bottom: 40 })
    }
}